import { PostHogProvider } from "posthog-js/react";
import { ReactNode, useEffect, useState } from "react";

import { usePostHogConfig } from "@/client/services/event-tracking";
import { useCookieConsent } from "@/client/hooks/use-cookie-consent";
import { PostHogAuthIntegration } from "./posthog-auth-integration";
import { PostHogPageTracking } from "./posthog-page-tracking";

type PostHogWrapperProps = {
  children: ReactNode;
};

export const PostHogWrapper = ({ children }: PostHogWrapperProps) => {
  console.log("PostHogWrapper component is rendering!");
  const { config, loading, error } = usePostHogConfig();
  const { hasNecessaryConsent } = useCookieConsent();
  const [shouldRenderProvider, setShouldRenderProvider] = useState(false);

  // Test direct axios call
  useEffect(() => {
    const testDirectCall = async () => {
      try {
        console.log("Testing direct axios call to /api/event-tracking/config");
        const response = await fetch("/api/event-tracking/config");
        const data = await response.json();
        console.log("Direct fetch result:", data);
      } catch (err) {
        console.error("Direct fetch failed:", err);
      }
    };
    testDirectCall();
  }, []);

  useEffect(() => {
    console.log("PostHogWrapper useEffect - loading:", loading, "config:", config, "error:", error);
    if (!loading) {
      setShouldRenderProvider(true);
    }
  }, [loading, config, error]);

  console.log(
    "PostHogWrapper render - loading:",
    loading,
    "shouldRenderProvider:",
    shouldRenderProvider,
    "config:",
    config,
  );

  // Show children without PostHog provider if still loading, no API key, or no analytics consent
  if (!shouldRenderProvider || loading || !config.apiKey || !config.host || !hasNecessaryConsent) {
    console.log("Rendering children without PostHog provider");
    return <>{children}</>;
  }

  // Initialize PostHog with the configuration from backend
  const options = {
    api_host: config.host,
  };

  console.log("Initializing PostHog with options:", options);

  return (
    <PostHogProvider apiKey={config.apiKey} options={options}>
      <PostHogAuthIntegration />
      <PostHogPageTracking />
      {children}
    </PostHogProvider>
  );
};
